import { ButtonProps, Button as MuiButton } from "@mui/material"

export const Button = ({ ...rest }: ButtonProps) => (
  <MuiButton color="secondary" variant="contained" {...rest} />
)
